import { useMemo } from 'react';

import { useAtomValue } from 'jotai';

import { openedModalsAtom } from 'src/stores/modal/atoms';
import { ModalType } from 'src/types/Modal';

export default function useIsOpenModal(key: ModalType) {
  const modals = useAtomValue(openedModalsAtom);
  const isOpen = useMemo(() => {
    return modals.some((modal) => modal.key === key);
  }, [key, modals]);
  return isOpen;
}
